import { m } from "@/paraglide/messages";
import type { Tool } from "../index";

export const iupacRegexTool: Tool = {
  id: "iupac-to-regex",
  name: () => m.iupac_tool_name(),
  description: () => m.iupac_tool_description(),
  icon: "🧬",
  basePath: "/iupac-to-regex",
  status: "stable",
  tags: ["bioinformatics", "dna", "regex", "sequence", "science", "iupac"],
};
